import {PersonInsuranceType} from './person-insurance';

export enum Duration {
  T1 = 'T1',
  T2 = 'T2',
  T3 = 'T3',
  T4 = 'T4',
  T5 = 'T5',
  T6 = 'T6',
  T7 = 'T7',
  T8 = 'T8',
  T9 = 'T9',
  T10 = 'T10',
  T11 = 'T11',
  T12 = 'T12',
  T13 = 'T13',
  T14 = 'T14',
  T15 = 'T15',
  T16 = 'T16',
  T17 = 'T17',
  T18 = 'T18',
  T19 = 'T19',
  T20 = 'T20',
  T21 = 'T21',
  T22 = 'T22',
  T23 = 'T23',
  T24 = 'T24',
  T25 = 'T25',
  T26 = 'T26',
  T27 = 'T27',
  T28 = 'T28',
  T29 = 'T29',
  T30 = 'T30',
  T31 = 'T31',
  T32 = 'T32',
  T33 = 'T33',
  T34 = 'T34',
  T35 = 'T35',
  T40 = 'T40',
  T45 = 'T45',
  T50 = 'T50',
  T65 = 'T65',
  T70 = 'T70',
  T75 = 'T75',
  T80 = 'T80',
  T85 = 'T85',
  T90 = 'T90',
  T95 = 'T95',
  T100 = 'T100',

  // Term to age #
  A50 = 'A50',
  A55 = 'A55',
  A60 = 'A60',
  A65 = 'A65',
  A70 = 'A70',
  A75 = 'A75',
  A80 = 'A80',
  A85 = 'A85',

  // # pay
  V1 = 'V1',
  V2 = 'V2',
  V3 = 'V3',
  V4 = 'V4',
  V5 = 'V5',
  V6 = 'V6',
  V7 = 'V7',
  V8 = 'V8',
  V9 = 'V9',
  V10 = 'V10',
  V11 = 'V11',
  V12 = 'V12',
  V13 = 'V13',
  V14 = 'V14',
  V15 = 'V15',
  V16 = 'V16',
  V17 = 'V17',
  V18 = 'V18',
  V19 = 'V19',
  V20 = 'V20',
  V21 = 'V21',
  V22 = 'V22',
  V23 = 'V23',
  V24 = 'V24',
  V25 = 'V25',
  V26 = 'V26',
  V27 = 'V27',
  V28 = 'V28',
  V29 = 'V29',
  V30 = 'V30',
  V40 = 'V40',
  V50 = 'V50',
  V60 = 'V60',
  V65 = 'V65',
  V70 = 'V70',
  V75 = 'V75',
  V80 = 'V80',
  V85 = 'V85',
  V90 = 'V90',
  V95 = 'V95',
  V100 = 'V100',

  // Pay to #
  P45 = 'P45',
  P50 = 'P50',
  P55 = 'P55',
  P60 = 'P60',
  P65 = 'P65',
  P70 = 'P70',
  P75 = 'P75',
  P80 = 'P80',
  P85 = 'P85',
  P100 = 'P100',
}

export function compareDurations(d1: Duration, d2: Duration): number {
  const d1Length = durationToNumber(d1);
  const d2Length = durationToNumber(d2);

  if (d1Length < d2Length) return -1;
  else if (d1Length > d2Length) return 1;
  else return 0;
}

export function findClosestDuration(durations: Duration[], duration: Duration): Duration {
  const targetDuration = durationToNumber(duration);

  return durations.reduce((prev, curr) =>
    Math.abs(durationToNumber(curr) - targetDuration) < Math.abs(durationToNumber(prev) - targetDuration)
      ? curr
      : prev,
  );
}

export function durationToNumber(duration: Duration): number {
  const nb = parseInt(duration.substring(1));
  if (Number.isNaN(duration)) {
    throw Error(`Could not convert the Duration to a number. Duration was: ${duration}`);
  }
  return nb;
}

export function isWholeLife(duration: Duration | string): boolean {
  const prefix = duration.substring(0, 1) as 'T' | 'A' | 'V' | 'P';
  switch (prefix) {
    case 'P':
    case 'V':
      return true;
    case 'A':
      return false;
    case 'T':
      return duration === Duration.T100;
    default:
      throw new Error(`Unsupported prefix for duration ${duration}`);
  }
}

export function getPersonInsuranceTypeFromDuration(duration: Duration | string): PersonInsuranceType {
  return isWholeLife(duration) ? 'WHOLE' : 'TERM';
}
